// extracted by mini-css-extract-plugin
module.exports = {"textLink":"links-module--text-link--2u5c6","button":"links-module--button--6OZC0"};